import moment from 'moment';
import { isValidPhoneNumber } from 'react-phone-number-input'

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const Validators = {
    required: (s: string) => {
        return s ? true : false;
    },
    requiredNotEmptyString: (s: string) => {
        return s && s !== '' ? true : false;
    },
    requiredArray: (s: any[]) => {
        return s.length ? true : false;
    },
    requiredBool: (s: string) => {
        return s === 'true';
    },
    email: (s: string) => {
        return emailRegex.test(s);
    },
    optionalPhone: (s: string) => {
        if (s === '' || s === undefined) {
            return true;
        }
        // console.log("phoneNum: " + s);
        return isValidPhoneNumber(s);
        // Only allow phone numbers between 7 and 15 digits (in the future you can try using https://github.com/googlei18n/libphonenumber)
        // This accepts any format, a wrong number can be input anyways
        // const match = s.match(digitRegex);
        // const letterMatch = s.match(letterRegex);
        // return match
            // ? match.length >= 7 && match.length <= 15 && letterMatch == null
            // : false;
    },
    date: (s: moment) => {
        return isValidDate(s);
        
    },
    childNotBornInFuture: (s: moment) => {
        // var moment = require('moment');
        // const birthdate = moment(s);
        //console.log(s, birthdate, !(birthdate.isBefore()));
        return (s.isBefore());

    },
    date18Plus: (s: moment) => {
        // var moment = require('moment');
        if (!(s instanceof moment) && !(s instanceof Date)) {
            return false;
        }
        const dateDiff = moment().diff(s, 'years', true);
        // console.log("Date Diff:", dateDiff);
        return (dateDiff >= 18);
    },
    ageLessThan18: (s: moment) => {
        return !Validators.date18Plus(s);
    },
    aboveMinimumAge: (s: moment) => {
        return (moment().diff(s, 'years', false) >= 3);
    },
    ageLessThanAgeCap: (s: moment) => {
        const ageCap = 120;
        // var moment = require('moment');
        const dateDiff = moment().diff(s, 'years', false);
        //console.log(dateDiff);
        return (dateDiff < ageCap);
    },
    nonNegativeInteger: (s: string) => {
        const num = parseInt(s, 10);
        return isNaN(num) === false && num >= 0;
    },
    passThrough: (s: string) => {
        return true;
    }
};

function isValidDate(d) {
    // console.log(d);
    // console.log(d instanceof Date || d instanceof moment);
    return (d instanceof Date || d instanceof moment) && !isNaN(d);
};

export type Validator = (s: string) => boolean;

export interface IValidatorPackage {
    validator: Validator;
    errorMessage: string;
}

export default Validators;
